import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import { UserOutlined, EyeOutlined, LeftCircleOutlined } from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { useLocation } from "react-router-dom";
import { Button, message, Form, InputNumber, } from 'antd';
import axios from "axios";
import consts from "../../constant";
import { type } from "@testing-library/user-event/dist/type";
import Nowallet from "../../Reusable/Nodata/Nowallet";
import { useNavigate } from "react-router-dom";



const UserWallet = () => {
  const [open, setOpen] = useState(false);
  const { state } = useLocation()
  const naigate = useNavigate();
  const [form] = Form.useForm();

  const [openBlock, setOpenBlock] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [totalPage, setTotalPage] = useState([])
  const [page, setPage] = useState(null)
  const [messageApi, contextHolder] = message.useMessage();
  const [wallet, setWallet] = useState([]);
  const [updateWallet, setUpdateWallet] = useState(null)
  const key = 'updatable';
  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'User Blocked',
    });
  };



  const showModal = (user) => {
    setOpen(true);
    setUpdateWallet(user)
  };


  const handleOkBlock = () => {
    // setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenBlock(false);
      setConfirmLoading(false);
      success()
    }, 2000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelBlock = () => {
    setOpenBlock(false);
  };

  const handleMenuClick = (e, user) => {
    console.log("Clicked:", e);
    if (e.key === "1") {
      // View
      showModal(user);
      form.setFieldsValue({
        future_balance: user?.future_balance,
      });
      // form.setFieldValue(user)
    }

  };

  const items = (user) => [
    { label: "Update", key: "1", icon: <EyeOutlined /> },

  ];


  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno", searchable: true },
    { title: "Asset Name", dataIndex: "ast", key: "ast", searchable: true },
    { title: "Symbol", dataIndex: "symbol", key: "symbol", searchable: true },
    { title: "Future Balance", dataIndex: "future_balance", key: "future_balance", searchable: true },
    { title: "Escrow Future Balance", dataIndex: "escrow_future_balance", key: "escrow_future_balance", searchable: true },


    {
      title: "Action",
      dataIndex: "select",
      key: "select",
    },
  ];

  const getWallet = async () => {
    try {
      const { data } = await axios.post(`${consts.BackendUrl}/admin/getWalletList?limit=10&page=${page?.current ? page?.current : 1}`,
        {
          user_id: state?.user?._id
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      )

      if (data?.success == true && data?.result?.docs) {
        var dts = data?.result?.docs;
        var totalCount = data?.result?.totalDocs;

        // var totalCount = data?.result?.totalDocs;
        // Map backend data into the table format
        const mappedData = dts.map((user, index) => {

          return {
            key: index, // REQUIRED for AntD Table
            sno: page?.current ? (page?.current - 1) * page?.pageSize + index + 1 : index + 1,
            // createdAt: formatCustomDate(user?.createdAt),
            ast: user?.assetname,
            escrow_future_balance: user?.escrow_future_balance,
            future_balance: user?.future_balance,
            symbol: user?.symbol,

            select: (
              <DropdownButton
                items={items(user)}
                label="More"
                onMenuClick={(e) => { handleMenuClick(e, user); }}
              />
            ),
          };
        });


        console.log(mappedData, 'dts');
        setTotalPage(totalCount)
        setWallet(mappedData);

      }

    } catch (error) {
      console.log(error?.response?.data?.message);

    }


  }

  const handleOk = async () => {


    try {
      const values = await form.validateFields();
      const { data } = await axios.post(`${consts.BackendUrl}/admin/updateUserWallet`, {
        userid: state?.user?._id,
        assetname: updateWallet?.assetname,
        amount: values?.future_balance

      },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      )
      // console.log(data, 'data');
      if (data?.success && data?.result) {

        setConfirmLoading(true);
        setTimeout(() => {
          setOpen(false);
          setConfirmLoading(false);
          getWallet()

          messageApi.open({
            type: 'success',
            content: `${updateWallet?.assetname} Balance Updated`,
          });
        }, 2000);

      }
    } catch (error) {
      console.log(error?.response?.data?.message);
    }

  };

  useEffect(() => {
    getWallet()
  }, [page])

  return (
    <>

      <div className="display-2 p-10">
        <div className="display-1">
          <LeftCircleOutlined style={{ fontSize: "20px", color: "#fff" }} className="cursor" onClick={() => { naigate(-1) }} />
          <h2 style={{ margin: '0px' }}>
            {state.user?.name?.charAt(0).toUpperCase() + state.user?.name?.slice(1).toLowerCase()} Wallet
          </h2>
        </div>


      </div >
      <Table columnsConfig={userColumns} data={wallet}
        total={totalPage} // 👈 pass backend total here
        pageSize={page?.pageSize ? page?.pageSize : 10}
        onChange={(pagination, filters, sorter) => {
          console.log("Table params:", pagination, filters, sorter);
          setPage(pagination)
        }}
      />

      <ReusableModal
        title={`Update Future Balance (${updateWallet?.assetname})`}
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okButtonProps={{
          disabled:
            form
              .getFieldsError()
              .some(({ errors }) => errors.length > 0) ||
            !form.getFieldValue("future_balance"),
          type: "primary", // ensures it’s still styled as a primary button
        }}
      >
        <Form
          name="wallet"
          layout="vertical"
          // onFinish={onFinish}
          initialValues={{ remember: true }}
          form={form}
        >
          {/* Email */}
          <Form.Item
            name="future_balance"
            label="Future Balance"
          // rules={[
          //     // { required: true, message: "Please enter a balance" },
          //     {
          //         validator: (_, value) =>
          //             value >= 20000
          //                 ? Promise.reject(new Error("Maximum Limit Reached"))
          //                 : Promise.resolve(),
          //     },
          // ]}
          >
            <InputNumber placeholder="" size="large" style={{ width: '100%' }} onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault(); // 👈 block non-numeric keys
              }
            }} />
          </Form.Item>
        </Form>
      </ReusableModal>


      {contextHolder}
    </>
  );
};

export default UserWallet;
